import { Color, HexColor } from '../Enum/Color';
import { NewsType } from '../Enum/Interest/NewsType';
import { Cell, LabelDeviation } from '../Interface/Hook/Interest/InterestTableDTO';
import { CellDecorator } from '../Enum/TableDecorator';

export const getLabelByColor = (color: Color): string => {
    switch (color) {
        case Color.Green:
            return 'Voldoende';
        case Color.Orange:
            return 'Twijfel';
        case Color.Red:
            return 'Onvoldoende';
        case Color.Blue:
            return 'Informatief';
        default:
            return 'N/A';
    }
};

export const getHexColorByResult = (result: Color | null): HexColor => {
    switch (result) {
        case Color.Green:
            return HexColor.Green;
        case Color.Orange:
            return HexColor.Orange;
        case Color.Red:
            return HexColor.Red;
        case Color.Blue:
            return HexColor.Blue;
        default:
            return HexColor.Grey;
    }
};

export const getColorByDeviationType = (type: NewsType): string | null => {
    switch (type) {
        case NewsType.LOWERED:
            return Color.Green;
        case NewsType.UPPED:
            return Color.Red;
        case NewsType.CHANGED:
            return Color.Orange;
        case NewsType.NEW:
            return Color.Blue;
        default:
            return null;
    }
};

export const getDeviationColor = (cells: Cell[]): string | null => {
    const deviationCell = cells.find(cell => cell.decorator === CellDecorator.LabelDeviation);
    if (undefined === deviationCell) return null;

    const labelDeviation = deviationCell.value as LabelDeviation;

    return getColorByDeviationType(labelDeviation.type as NewsType);
};
